import { Transition } from "@headlessui/react";
import { SearchIcon } from "@heroicons/react/outline";
import firebase from "firebase/app";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import { useState } from "react";

import { AnalyticsEventEnum } from "@/consts/AnalyticsEventEnum";
import { SearchQueryKeyEnum } from "@/consts/SearchQueryKeyEnum";
import { useSearchQuery } from "@/features/search/hooks/useSearchQuery";

const SearchMenu = dynamic(
  () => import("@/features/search/components/SearchMenu"),
  { ssr: false },
);

export const Search = () => {
  const { t } = useTranslation();
  const {
    searchBoxText,
    searchBoxOnChange: onChange,
    query,
    onSubmit,
  } = useSearchQuery();

  const [focusingInput, setFocusingInput] = useState(false);

  const showMenu = !!query && focusingInput;

  return (
    <>
      <div className="relative flex w-full h-full items-center">
        <form onSubmit={onSubmit} className="contents">
          <div className="w-full flex items-center bg-gray-100 rounded-20 border-solid border focus-within:border-primary px-4 py-2 space-x-2">
            <SearchIcon className="w-4 h-4" />
            <input
              type="search"
              autoComplete="off"
              name={SearchQueryKeyEnum.Post}
              value={searchBoxText}
              onChange={onChange}
              onFocus={() => {
                firebase
                  .analytics()
                  .logEvent(AnalyticsEventEnum.SearchDesktopOpen);
                setFocusingInput(true);
              }}
              placeholder={t("common:search.placeholder")}
              className="text-base outline-none bg-gray-100 border-none w-full"
            />
          </div>
        </form>

        {showMenu && (
          <div className="w-full absolute top-16 z-10">
            <SearchMenu query={query} />
          </div>
        )}
      </div>

      <Transition
        show={showMenu}
        enter="ease-out duration-100"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-100"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div
          className="fixed flex justify-center inset-0 top-16 bg-black opacity-70"
          onClick={() => {
            firebase
              .analytics()
              .logEvent(AnalyticsEventEnum.SearchDesktopClose);
            setFocusingInput(false);
          }}
        />
      </Transition>
    </>
  );
};
